import { ArrowUp } from "lucide-react";
import { CONTACT } from "../data/content";
import { scrollToTarget, useISTClock } from "./ui-bits";

export default function Footer() {
  const time = useISTClock();
  return (
    <footer data-testid="footer" className="border-t border-white/10 bg-ink/50">
      <div className="mx-auto flex max-w-7xl flex-col gap-8 px-5 py-12 md:flex-row md:items-center md:justify-between md:px-8">
        <div data-testid="footer-identity">
          <p className="font-display text-3xl font-bold uppercase tracking-wide text-white md:text-4xl">{CONTACT.name}</p>
          <p className="mt-1 font-mono text-[10px] tracking-[0.25em] text-ember">GRAPHIC DESIGNER &amp; WEB DESIGNER</p>
        </div>
        <div className="flex flex-wrap items-center gap-2" data-testid="footer-socials">
          {CONTACT.socials.map((s) => (
            <a
              key={s.label}
              href={s.url}
              target="_blank"
              rel="noreferrer"
              data-testid={`footer-social-${s.label.toLowerCase()}`}
              className="btn-fill px-4 py-2.5 font-mono text-[10px] tracking-[0.2em]"
            >
              {s.label.toUpperCase()}
            </a>
          ))}
          <button
            onClick={() => scrollToTarget(0)}
            data-testid="footer-return-to-base"
            aria-label="Back to top"
            className="btn-fill ml-2 flex h-10 w-10 items-center justify-center"
          >
            <ArrowUp className="h-4 w-4" />
          </button>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-5 py-5 font-mono text-[9px] tracking-[0.22em] text-slate-500 md:flex-row md:px-8">
          <span data-testid="footer-copyright">© {new Date().getFullYear()} {CONTACT.name.toUpperCase()}</span>
          <span data-testid="footer-clock" className="flex items-center gap-2.5 font-mono text-sm tracking-[0.3em] text-ember">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-ember opacity-60" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-ember" />
            </span>
            {time} IST
          </span>
          <span>DESIGNED AT ALTITUDE — 28.5706° N / 77.3272° E</span>
        </div>
      </div>
    </footer>
  );
}
